import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { Component } from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';
import moment from 'moment';
import { v4 as uuidV4 } from 'uuid';
import ListPanel from '../../common/containers/listPanel';
import ReportTagsContainer from './reportTagsContainer';
import TreeView from './treeView/treeView';
import entityComposition from '../../common/classes/entityComposition';
import { highestOrder, findNode, moveNodes } from './reportTagHelpers';
import { editPermissionSelector, viewPermissionSelector } from '../../common/classes/permissions';
import routeHelper from '../../common/classes/routeHelper';
class ReportTags extends Component {
  constructor(props) {
    super(props);
    this.handleAdd = this.handleAdd.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
    this.handleMove = this.handleMove.bind(this);
    this.handleAddTopNode = this.handleAdd.bind(this, null, null);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleSearchClear = this.handleSearch.bind(this, '');
    this.state = {};
  }
  componentDidMount() {
    const _this$props = this.props,
      serverIndex = _this$props.reportTagActions.serverIndex,
      indexQuery = _this$props.reportTag.indexQuery,
      canView = _this$props.canView,
      location = _this$props.location;
    routeHelper.handleViewRedirect(canView, location);
    serverIndex(indexQuery);
  }
  handleMove(from, to, index) {
    const _this$props2 = this.props,
      list = _this$props2.reportTag.list,
      serverSaveAll = _this$props2.reportTagActions.serverSaveAll;
    const updatedNodes = moveNodes(from, to, index, list);
    serverSaveAll(updatedNodes);
  }
  handleSearch(text) {
    const _this$props3 = this.props,
      serverFilter = _this$props3.reportTagActions.serverFilter,
      indexQuery = _this$props3.reportTag.indexQuery;
    serverFilter({
      text
    }, indexQuery);
  }
  handleAdd() {
    let parentID = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    let treeNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    const _this$props4 = this.props,
      list = _this$props4.reportTag.list,
      userID = _this$props4.userID,
      serverSave = _this$props4.reportTagActions.serverSave;
    const nextOrder = highestOrder(list) + 1;
    const tag = {
      name: "New Report Tag - ".concat(nextOrder),
      nodes: [],
      sortOrder: nextOrder,
      parentID
    };
    const defaults = _objectSpread({
      id: uuidV4().toUpperCase(),
      appCreatorID: userID,
      appCreated: moment().utc().format('YYYY-MM-DD HH:mm:ss'),
      isNew: true
    }, tag);
    serverSave(defaults);
    if (treeNode) {
      treeNode.setState({
        expanded: true
      });
    }
  }
  handleRemove(id) {
    const _this$props5 = this.props,
      list = _this$props5.reportTag.list,
      serverDestroy = _this$props5.reportTagActions.serverDestroy,
      notificationActions = _this$props5.notificationActions;
    const removeTag = findNode(id, {
      id: null,
      nodes: list
    });
    if (removeTag.nodes && removeTag.nodes.length > 0) {
      // can't remove tag until children are removed...
      notificationActions.error({
        message: 'You must remove the tag children before this Report Tag can be removed.'
      });
    } else {
      serverDestroy([id]);
    }
  }
  render() {
    const _this$props6 = this.props,
      canEdit = _this$props6.canEdit,
      _this$props6$reportTa = _this$props6.reportTag,
      list = _this$props6$reportTa.list,
      indexQuery = _this$props6$reportTa.indexQuery,
      serverSave = _this$props6.reportTagActions.serverSave;
    let nodes = [];
    nodes = _.toArray(list);
    if (!_.isArray(nodes)) {
      nodes = [];
    }
    let tree = null;
    if (!_.isEmpty(list)) {
      tree = /*#__PURE__*/React.createElement(TreeView, {
        nodes: nodes,
        enableEdit: canEdit,
        onMove: this.handleMove,
        onAdd: this.handleAdd,
        onRemove: this.handleRemove,
        onSave: serverSave
      });
    }
    return /*#__PURE__*/React.createElement(ReportTagsContainer, {
      filters: indexQuery.filters,
      onSearch: this.handleSearch,
      onSearchClear: this.handleSearchClear
    }, /*#__PURE__*/React.createElement(ListPanel, {
      title: "Report Tags",
      showNew: canEdit,
      onAdd: this.handleAddTopNode,
      onChange: this.onChange
    }, tree));
  }
}
ReportTags.propTypes = {
  canEdit: PropTypes.bool.isRequired,
  canView: PropTypes.bool.isRequired,
  location: PropTypes.shape({}).isRequired,
  userID: PropTypes.string.isRequired,
  reportTag: PropTypes.shape({
    list: PropTypes.arrayOf(PropTypes.shape({})),
    indexQuery: PropTypes.shape({
      filters: PropTypes.shape({})
    })
  }).isRequired,
  reportTagActions: PropTypes.shape({
    serverSave: PropTypes.func,
    serverSaveAll: PropTypes.func,
    serverDestroy: PropTypes.func,
    serverIndex: PropTypes.func,
    serverFilter: PropTypes.func
  }).isRequired,
  notificationActions: PropTypes.shape({
    error: PropTypes.func
  }).isRequired
};
export { ReportTags as TestReportTags };
export default entityComposition(ReportTags, ['reportTag'], {
  userID: state => state.login.user.user_id,
  canView: state => viewPermissionSelector('reportTag')(state),
  canEdit: state => editPermissionSelector('reportTag')(state)
}, ['notification']);